export { StepSwitcherImmediate };
function StepSwitcherImmediate() {
   let container = $('#stepsContainer'),
      containerPrefetch = $('#stepsContainer-prefetch');

   return {
      show: function (element, index) {
         container.empty();
         container.append(element).show();
      },
      prefetch: function (element, index) {
         // Don't move the element if it's already in the visible container.
         if (container.has(element).length) {
            return;
         }

         containerPrefetch.empty();
         containerPrefetch.append(element);
      },
   };
}
